// extracted by mini-css-extract-plugin
export default {"page":"FaqPage_page__MdR-g"};